import {
    maxEmail,
    maxMobile,
    maxName,
    maxPassword,
    minMobile,
    minName,
    minPassword,
    validations,
} from "./validations";

export const formRules: any = {
    name: (min?: number, max?: number, field?: string) => [
        validations.required.text(field),
        validations.min.text(minName, field),
        validations.max.text(maxName, field),
    ],
    phone: (field?: string) => [validations.required.text(field)],
    mobileNumber: (field?: string) => [
        validations.required.text(field),
        validations.pattern.numeric(),
        validations.min.text(minMobile, field),
        validations.max.text(maxMobile, field),
    ],
    email: (max?: number, field?: string) => [
        validations.required.text(field),
        validations.max.text(maxEmail, field),
        validations.email(field),
    ],
    password: (min = minPassword, max = maxPassword, field?: string) => [
        validations.required.text(field),
        validations.pattern.password(field),
        validations.min.text(min),
        validations.max.text(max),
    ],
};
